



























import { Vue, Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class DataFetcher extends Vue {
	@Prop() id?: string; // ID passed as a prop (from route)

	@Prop({
		type: Function,
		required: true
	})
	readonly fetchData!: () => Promise<void>;

	@Prop({
		type: Function,
		required: false
	})
	readonly secondaryFetchData?: () => Promise<void>;

	@Prop({
		type: Boolean,
		required: false,
		default: false
	})
	readonly useSilentLoading!: boolean;

	@Prop({
		type: Boolean,
		required: false,
		default: false
	})
	readonly hideLoading!: boolean;

	loading = false;
	silentLoading = false;
	error = false;

	async created() {
		await this.handleLoad();
	}


	// Watch for route param changes (id change)
	@Watch("id")
	async onIdChange() {
		if (this.useSilentLoading) {
			this.silentLoading = true;
		}
		await this.handleSecondaryLoad();
	}

	async handleLoad() {
		this.loading = true;
		this.$emit("update:isLoading", this.loading);

		try {
			await this.fetchData();
			this.error = false;
		} catch (error) {
			this.error = true;
		}
		this.loading = false;
		this.$emit("update:isLoading", this.loading);

		this.silentLoading = false;
	}

	async handleSecondaryLoad() {
		this.loading = true;
		this.$emit("update:isLoading", this.loading);

		try {
			if (this.secondaryFetchData) {
				await this.secondaryFetchData();
			}
			else {
				await this.fetchData();
			}
			this.error = false;
		} catch (error) {
			this.error = true;
		}
		this.loading = false;
		this.$emit("update:isLoading", this.loading);

		this.silentLoading = false;
	}
}
